export const resource = {
  error: "Your request could not be processed. Try again later.",
  suggestionInfo: "Suggested accounts are based on your interests and connections. Your account may also be suggested to others.",
  followerMsg: "Messages will appear here",
  newFollowerNullSet: "Followers will appear here",
  userPrivacySettings: "Unable to receive your message due to privacy settings",
  storePrivacySettings: "Store unable to receive your message due to privacy settings",
  deliverPrivacySettings: "Unable to deliver due to privacy settings",
  startedFollowingYou: "Started following you",
  cannotFollow: "You cannot follow this account.",
  userBlock: "{0} blocked",
  userUnBlock: "{0} unblocked",
  userPinned: "Conversation pinned",
  userUnPinned: "Conversation unpinned",
  userMute: "Notifications muted",
  userUnMute: "Notifications unmuted",
  messageCopied: "Message copied",
  messageIsTooLong: "Message exceeds the limit",
  startedFollowing: "Started following your store",
  newFollowerStoreNullSet: "Store followers will appear here",
  quotationRequest: "Requests will appear here",
  privacyMessage: "You cannot follow this account due to this user's privacy settings."
};
